export enum ContractSignerType {
    Merchant = 1,
    Producer = 2
}